import Copyright from '@atoms/Copyrights/Copyright';
import React from 'react';
import styled from 'styled-components';

const Footer = () => {
    return (
        <FooterWithStyled>
            <Copyright>Copyright &copy; grandata co.,td, All Rights Reserved.</Copyright>
        </FooterWithStyled>
    );
};

const FooterWithStyled = styled.footer`
`

export default Footer;